import React, { useEffect } from 'react'
import { makeAutoObservable } from 'mobx'
import { observer } from 'mobx-react-lite'
import { toast } from 'react-toastify'
import moment from 'moment'
import AdminApi from './../../../../api/admin-api/admin-api'
import { Subscription, of } from 'rxjs'
import SubmitSalesService from './../../shared/SubmitSales.service'
import UserProfileService from './../../../../shared/services/UserProfile.service'
import MaxAvDateStore from './../../store/max-av-date.store'
import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardFooter, MDBListGroup, MDBListGroupItem } from 'mdb-react-ui-kit'
import appConstants from '../../../../constants/appConstants'

import './RecentApplications.scss'

class RecentAppStore {
  userId = null
  recentSales = []

  constructor() {
    makeAutoObservable(this)
  }

  getRecentSales = async () => {
    const response = await AdminApi.getAgentRecentFiveSales()

    if (response && Array.isArray(response?.data?.data)) this.recentSales = response.data.data
  }
}

const Store = new RecentAppStore()

const RecentApplications = observer(() => {
  const { getRecentSales, recentSales } = Store,
    userId = UserProfileService.getUserId()

  useEffect(() => {
    getRecentSales()
  }, [userId])

  const renderAvDate = av => {
    let { av_date } = av || {}

    if (av_date && typeof av_date === 'string') av_date = av_date.trim().split(/T| /).shift()

    return (
      <span className='text-center'>
        {moment(av_date || av?.av_date).format('MMM Do')} - {av.av_client}
      </span>
    )
  }

  return (
    <div id='RecentApplications'>
      <MDBCard>
        <MDBCardHeader color='indigo'>
          <h5 className='white-text mt-2 text-center'>
            Recent
            <br />
            Applications
          </h5>
        </MDBCardHeader>
        <MDBCardBody>
          <MDBListGroup>
            {recentSales && recentSales.length ? (
              recentSales.map((item, i) => {
                return (
                  <MDBListGroupItem className='text-center' key={`av-recent-app-${i}`}>
                    {renderAvDate(item)}
                    <br />
                    <span className='text-center'>{item.av_carrier} </span>
                    <br />
                    <span className='text-center'>
                      <strong>(Pts: {item.av_points})</strong>
                    </span>
                    <br />
                    <span className='text-center'>
                      <span
                        className='text-info cursor-pointer'
                        onClick={() => (window.location.href = `/submit-sales/${item.av_id}/edit`)}
                      >
                        View
                      </span>
                    </span>
                  </MDBListGroupItem>
                )
              })
            ) : (
              <p className='text-center mt-3'>
                <strong>No Recent Sales</strong>
              </p>
            )}
          </MDBListGroup>
        </MDBCardBody>
        <MDBCardFooter>
          <MDBListGroup>
            <MDBListGroupItem className='text-center'>
              <a href='/reporting/my-production'>View Past Sales</a>
            </MDBListGroupItem>
          </MDBListGroup>
        </MDBCardFooter>
      </MDBCard>
    </div>
  )
})

export default RecentApplications
